<template>
  <q-card flat bordered>
    <q-card-section class="q-pa-sm bg-primary text-white">
      <div class="row justify-between">
        <div class="text-subtitle1 text-bold">
          <q-icon name="map" style="font-size: 25px; padding-right: 0.1rem" />
          Maps
        </div>
        <q-btn
          dense
          label="Check Full Path"
          color="secondary"
          size="sm"
          class="float-right q-px-sm"
          style="top: 3px"
          @click="handleCheckFullPath"
        />
      </div>
    </q-card-section>

    <q-separator />
    <q-card-section>
      <div class="row q-gutter-x-sm">
        <div class="col">
          <div
            v-if="!loadingOrigin && !loadingMapApi"
            style="width: 100%; height: 260px; position: relative"
          >
            <map-box-map-loader :center="originCenter" />
          </div>
          <q-skeleton v-else type="rect" height="260px" animation="fade" />
        </div>
        <div class="col">
          <div
            v-if="!loadingDestination && !loadingMapApi"
            style="width: 100%; height: 260px; position: relative"
          >
            <map-box-map-loader :center="destinationCenter" />
          </div>
          <q-skeleton v-else type="rect" height="260px" animation="fade" />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import graphql from '@client/graphql';
import MapBoxMapLoader from './mapbox-map';

export default {
  components: {
    MapBoxMapLoader
  },
  data() {
    return {
      loadingMapApi: true,
      loading: true,
      loadingOrigin: true,
      loadingDestination: true,
      GMAP_API_KEY: window.GOOGLE_MAP_API_KEY_FOR_CLIENT,
      mapConfig: {
        zoom: 5,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
      },
      origin: {},
      destination: {},
      originCenter: { lat: 0, lng: 0 },
      destinationCenter: { lat: 0, lng: 0 },
      fullPath: null
    };
  },

  methods: {
    async refreshMap({ origin, destination }) {
      this.loadingMapApi = true;
      this.loadingDestination = true;
      this.loadingOrigin = true;

      if (!origin || !this.originCenter) {
        this.originCenter = '';
      } else if (!this.$zipLocationsCenters[origin.zipcode]) {
        this.$zipLocationsCenters[origin.zipcode] = true;
        const response = await this.$apollo.query({
          query: graphql.queries.getGeolocation,
          variables: { zipcode: origin.zipcode }
        });
        const originPlace = response.data.getGeolocation;
        this.originCenter = [originPlace.lng, originPlace.lat];

        this.$zipLocationsCenters[origin.zipcode] = this.originCenter;
        this.loadingOrigin = false;
      } else if (this.$zipLocationsCenters[origin.zipcode] !== true) {
        this.originCenter = this.$zipLocationsCenters[origin.zipcode];
        this.loadingOrigin = false;
      }
      this.origin = origin;

      if (!destination || !this.destinationCenter) {
        this.destinationCenter = '';
      } else if (!this.$zipLocationsCenters[destination.zipcode]) {
        this.$zipLocationsCenters[destination.zipcode] = true;
        const response = await this.$apollo.query({
          query: graphql.queries.getGeolocation,
          variables: { zipcode: destination.zipcode }
        });
        const destinationPlace = response.data.getGeolocation;
        this.destinationCenter = [destinationPlace.lng, destinationPlace.lat];

        this.$zipLocationsCenters[destination.zipcode] = this.destinationCenter;
        this.loadingDestination = false;
      } else if (this.$zipLocationsCenters[destination.zipcode] !== true) {
        this.destinationCenter = this.$zipLocationsCenters[destination.zipcode];
        this.loadingDestination = false;
      }
      this.destination = destination;
      this.loadingMapApi = false;

      this.fullPath = `https://maps.google.com/maps?q=from+${origin.city},+${origin.state}+${origin.zipcode}+to+${destination.city},+${destination.state}+${destination.zipcode}`;
    },
    handleCheckFullPath() {
      window.open(this.fullPath);
    }
  }
};
</script>
<style lang="scss"></style>
